import { collectionGridSetup, collectionGridEnter } from './collection-grid.js';
import { fullscreenImageSetup, fullscreenImageEnter } from './fullscreen-image.js';
import { halfGallerySetup, halfGalleryEnter } from './half-gallery.js';
import { draggableCarouselSetup, draggableCarouselEnter } from './draggable-carousel.js';
import { twoImagesGallerySetup, twoImagesGalleryEnter } from './two-images-gallery.js';
import { textSetup, textEnter } from './text.js';
import { breadcrumbsSetup, breadcrumbsEnter } from './breadcrumbs.js';
import { productPageSetup, productPageEnter } from './product-page.js';
import { relatedProductsSetup, relatedProductsEnter } from './related-products.js';

const setup = new Map();
setup.set('collection-grid', collectionGridSetup);
setup.set('fullscreen-image', fullscreenImageSetup);
setup.set('half-gallery', halfGallerySetup);
setup.set('draggable-carousel', draggableCarouselSetup);
setup.set('two-images-gallery', twoImagesGallerySetup);
setup.set('text', textSetup);
setup.set('breadcrumbs', breadcrumbsSetup);
setup.set('product-page', productPageSetup);
setup.set('related-products', relatedProductsSetup);

const enter = new Map();
enter.set('collection-grid', collectionGridEnter);
enter.set('fullscreen-image', fullscreenImageEnter);
enter.set('half-gallery', halfGalleryEnter);
enter.set('draggable-carousel', draggableCarouselEnter);
enter.set('two-images-gallery', twoImagesGalleryEnter);
enter.set('text', textEnter);
enter.set('breadcrumbs', breadcrumbsEnter);
enter.set('product-page', productPageEnter);
enter.set('related-products', relatedProductsEnter);

const leave = new Map();

export { setup, enter, leave };